export default __webpack_public_path__ + "static/media/stunned_green.bce6d2d3.png";